var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.clientes,"clearable":"","outlined":"","dense":"","item-text":"nome_fantasia","item-value":"cliente_id","hide-details":"","label":"Clientes"},on:{"click:clear":_vm.clearCliente},model:{value:(_vm.cliente),callback:function ($$v) {_vm.cliente=$$v},expression:"cliente"}})
}
var staticRenderFns = []

export { render, staticRenderFns }